import React from "react";
import "../assets/css/material-kit.css";

const Footer = () => {

  return (
    <footer className="footer bg-dark text-white text-center py-4">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-12 text-lg-start text-center mb-3 mb-lg-0">
            <p className="mb-0">
              &copy; {new Date().getFullYear()} SyncOrb-AI. All rights reserved.
            </p>
          </div>
          <div className="col-lg-6 col-md-12 text-lg-end text-center">
            <div className="social-links">
              <span className="me-3 d-none d-sm-inline text-muted">Follow us:</span>
              <a 
                href="https://www.linkedin.com/company/syncorb-ai"
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link me-3"
                aria-label="Follow us on LinkedIn"
                title="LinkedIn"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a 
                href="https://twitter.com/syncorbai" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link me-3"
                aria-label="Follow us on Twitter"
                title="Twitter"
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a 
                href="https://www.instagram.com/syncorbai" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Follow us on Instagram"
                title="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12">
            <a href="/terms-of-service" className="text-white me-3" title="Terms of Service">
              Terms of Service
            </a>
            <a href="/privacy-policy" className="text-white" title="Privacy Policy">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
